export type StateType = {
  isVehicleTrackingSimulated: boolean;
};

export const initialState: StateType = {
  isVehicleTrackingSimulated: false,
};
export default initialState;
